import React from "react";
import HintPopover from "../HintPopover";
import infoIkona from "../../obr/info-circle.svg";

const LIMIT_KLIKACIEHO_TEXTU = 280;

export default function AdminInfoIkona({ obsah, nazov }) {
  const text = typeof obsah === "string" ? obsah : "";
  const jeKlikaci = text.length > LIMIT_KLIKACIEHO_TEXTU || /\r?\n/.test(text);

  return (
    <HintPopover obsah={obsah} ariaLabel={`Informácie: ${nazov}`} pozicia="right" triggerMode={jeKlikaci ? "click" : "hover"}>
      <img src={infoIkona} className="admin-info-icon" alt="" />
    </HintPopover>
  );
}
